var exports = {
  "a": "Box__uG_tKF",
  "w": "Box_1__IRCI9d",
};

module.exports = exports;
